import React, { useState, useEffect } from "react";
import { toAbsoluteUrl } from "../../../toAbsoluteUrl";
// import "../Styles/globals.css";

import { callApi } from "../../../API";
// import Pagination from "../../Components/pagination";
// import { useNavigate } from "react-router-dom";
// import BreadcrumbsComponent from "../../Components/Breadcrumbs.jsx";

export default function WalletInformation(props) {
  const [WalletInformation, setWalletInformation] = useState({});
  useEffect(() => {
    getWalletInformation();
  }, []);
  function getWalletInformation() {
    const domain = window.API_DASHBOARD_DATA;
    callApi(domain, {
      type: "userWalletData",
      // bussinessUserId: "2974",
    })
      .then((data) => {
        console.log("data ==== ---- ===== ---- === >>", data);
        setWalletInformation(data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  return (
    <div className="main-wallet-information-section mt-5">
      {/* <wallet-icon.svg */}
      <img
        src={toAbsoluteUrl("/media/images/wallet-icon.svg")}
        alt="wallet-icon"
        className="wallet-icon"
      />
      <div className="wallet-information">
        <div className="balance-of-wallet">
          <div>
            <h3>Available balance:</h3>
            <h3 className="mt-1">AED {WalletInformation.availableBalance}</h3>
          </div>
          <a
            onClick={() => props.handleOpen()}
            className="rounded-btn gap-12 invite-btn top-up-btn display-flex-with-center font-weight-600 gap-12"
          >
            <img
            className="d-md-block d-none"
              src={toAbsoluteUrl("/media/images/plus-with-background.svg")}
              alt="plus-icon"
            />
            Top-up Wallet
          </a>
        </div>
        <div className="divider " />
        <div className="last-transaction-wallet">
          <div>
            <span>Wallet ID</span>
            <p>{WalletInformation.walletId}</p>
          </div>
          <div>
            <span>Last top-up amount</span>
            <p>AED {WalletInformation.lastTopup}</p>
          </div>
          <div>
            <span>Last top-up date</span>
            <p>{WalletInformation.lastTopupDateFormatted}</p>
          </div>
          <div>
            <span>Last transaction date</span>
            <p>{WalletInformation.lastTransactionDateFormatted}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
